import { Modal } from "react-bootstrap";

export default function IceBreakerModal({ show, onHide }) {
	return (
		<Modal show={show} onHide={onHide}>
			<Modal.Header closeButton>
				<Modal.Title className="d-flex align-items-center gap-2">
					<i className="bi bi-info-circle-fill text-info"></i>
					<span className="d-flex align-items-center gap-2">
						What is Icebreaker?
						<img
							src="/images/icebreaker.png"
							alt="Icebreaker icon"
							style={{ width: "28px", height: "28px", objectFit: "contain" }}
						/>
					</span>
				</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<p className="my-3">
					It's an AI to help start conversations! <br />
					It only works when you are 'Attending' an event{" "}
					<i className="bi bi-check me-2" style={{ fontSize: "1.5rem", lineHeight: 0, verticalAlign: "middle" }}></i>
					<br />
					Try it out!
				</p>
			</Modal.Body>
		</Modal>
	);
}
